import React from 'react';

export default function Tag(props) {
    return (
        <button className='bg-tv-red text-white px-2 py-1 text-xxs tracking-wide'>{props.data.name}</button>
    );
}